import React from "react";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDatePickerProps,
} from "@material-ui/pickers";

interface DateTimeWraperProps {
  children: React.ReactElement;
}

const DateTimeWraper = ({
  children,
}: DateTimeWraperProps): React.ReactElement => (
  <MuiPickersUtilsProvider utils={MomentUtils}>
    {children}
  </MuiPickersUtilsProvider>
);

export const DatePicker = (
  props: KeyboardDatePickerProps,
): React.ReactElement => (
  <DateTimeWraper>
    <KeyboardDatePicker
      animateYearScrolling
      variant="inline"
      format="DD/MM/YYYY"
      {...props}
    />
  </DateTimeWraper>
);
